import styled from "styled-components";

export const PackagingLevelsWrapper = styled.div`
  width: 100%;
  max-width: 60rem;
  margin: 2rem auto 0;
  padding: 2.5rem;
  border-top: 1px solid ${({ theme }) => theme.text.prim_400};
  background-color: ${({ theme }) => theme.bg.prim_500};
  border-radius: 0.25rem;

  .text-prompt {
    margin-bottom: 1.5rem;

    p {
      margin-top: 0.4rem;
      font-size: 0.85rem;
      color: ${({ theme }) => theme.text.prim_100};
    }
  }

  .level-row {
    width: 100%;
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 1.5rem 4%;
    margin-bottom: 2rem;
    position: relative;

    .remove-level {
      display: flex;
      align-items: center;
      gap: 0.4rem;
      margin-left: auto;
      background: none;
      border: none;
      cursor: pointer;
      font-size: 0.8rem;
      color: ${({ theme }) => theme.text.error};

      svg {
        font-size: 0.7rem;
      }
    }
  }

  .add-level {
    width: 100%;
    display: flex;
    justify-content: flex-end;

    button {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      background: none;
      border: 1px solid ${({ theme }) => theme.text.progress};
      color: ${({ theme }) => theme.text.progress};
      border-radius: 0.25rem;
      padding: 0.6rem 1.2rem;
      font-size: 0.9rem;
      cursor: pointer;

      svg {
        font-size: 0.8rem;
      }
    }

    .max-reached {
      font-size: 0.85rem;
      color: ${({ theme }) => theme.text.prim_100};
    }
  }
`;
